// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"334":"9ecf979d54ff36f2","659":"aa7ed8b47a9a70ba"}[chunkId] + ".css";
};